import { Col, Row } from "react-bootstrap";
import LicenceProfileHeader from "../LicenceProfileHeader";
import LicenceProfileSubTabs from "../LicenceProfileSubTabs";
import BreadCrumbs from "./BreadCrumbs";
import { useParams } from "react-router-dom";
import RelatedComplianceRecords from "./RelatedComplianceRecords";
import Page404 from "../../../pages/auth/Page404";
import useAppSelector from "../../../hooks/useAppSelector";
import {
  loadLicenceProfileAsync,
  selectLicenceProfileResponse,
} from "../../../redux/slices/licenceProfile";
import useAppDispatch from "../../../hooks/useAppDispatch";
import Loading from "../../../leap-components/Loading";
import BackToCompliance from "../ComplianceTab/BackToCompliance";
import { useState } from "react";
import {
  GetLicenceProfileNotReadyComponent,
  IsLicenceProfileReady,
} from "../../../leap-components/LicenceProfile/LicenceProfileResponseComponentFactory";
import { ILicenceProfile } from "../../../api/ILicenceProfile";
import EpaCorrespondenceHeader from "./EpaCorrespondenceHeader";
import EpaCorrespondenceDetails from "./EpaCorrespondenceDetails";
import {
  loadEpaCorrespondenceAsync,
  selectEpaCorrespondence,
} from "../../../redux/slices/epaCorrespondence";
import Page500 from "../../../pages/auth/Page500";

const EpaCorrespondence = () => {
  const [loading, setLoading] = useState(false);
  const [loadingEpaCorrespondenceId, setLoadingEpaCorrespondenceId] =
    useState("");
  const licenceProfileSelector = useAppSelector(selectLicenceProfileResponse);
  const epaCorrespondenceSelector = useAppSelector(selectEpaCorrespondence);

  const dispatch = useAppDispatch();

  let { profileNo, epaCorrespondenceId } = useParams();
  if (!profileNo || !epaCorrespondenceId) {
    return <Page404 />;
  }

  if (!loading) {
    setLoading(true);
    dispatch(loadLicenceProfileAsync(profileNo));
  }

  if (!IsLicenceProfileReady(licenceProfileSelector.licenceProfileResponse)) {
    return GetLicenceProfileNotReadyComponent(
      licenceProfileSelector.licenceProfileResponse
    );
  }

  const licenceProfile = licenceProfileSelector.licenceProfileResponse
    ?.licenceProfile as ILicenceProfile;

  if (loadingEpaCorrespondenceId !== epaCorrespondenceId) {
    setLoadingEpaCorrespondenceId(epaCorrespondenceId);
    dispatch(loadEpaCorrespondenceAsync(epaCorrespondenceId));
    return <Loading />;
  }

  const epaCorrespondence = epaCorrespondenceSelector.epaCorrespondence;

  if (!epaCorrespondence) {
    return <Loading />;
  }

  if (!epaCorrespondence.response.ok) {
    if (epaCorrespondence.response.status === 404) {
      return <Page404 />;
    } else {
      return <Page500 />;
    }
  }

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <EpaCorrespondenceHeader epaCorrespondence={epaCorrespondence} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <EpaCorrespondenceDetails epaCorrespondence={epaCorrespondence} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12">
          <BackToCompliance profileNo={profileNo} />
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <RelatedComplianceRecords
            epaCorrespondence={epaCorrespondence}
            licenceProfile={licenceProfile}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs
        licenceProfile={licenceProfile}
        epaCorrespondence={epaCorrespondence}
      />
      <div className="ps-0">
        <LicenceProfileHeader licenceProfile={licenceProfile} />
        <LicenceProfileSubTabs
          activeKey="compliance-records"
          content={contentElement}
          licenceProfile={licenceProfile}
        />
      </div>
    </div>
  );
};

export default EpaCorrespondence;
